import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { theme } from "@financial-advisory/theme";
import { BrandingProvider } from "@targeted-support/ui/contexts";
import { TargetedSupportApp } from "@targeted-support/ui/features/app";
import { RequireAuth } from "./RequireAuth";

export const AppRouter = () => (
  <ThemeProvider theme={theme}>
    <RequireAuth>
      <BrandingProvider>
        <Routes>
          <Route index element={<TargetedSupportApp />} />
        </Routes>
      </BrandingProvider>
    </RequireAuth>
  </ThemeProvider>
);
